import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { createPayment, verifyPayment } from "../../services/paymentApi";
import API from "../../services/api";

const PaymentPage = () => {
  const { orderId } = useParams(); // DB ID (INT)
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const hasRun = useRef(false);

  const handlePayment = async () => {
    try {
      setLoading(true);

      // =========================
      // 1. GET ORDER
      // =========================
      const orderRes = await API.get(`/orders/payment/${orderId}`);

      const order = orderRes.data.order;
      const items = orderRes.data.items || [];

      console.log("ORDER:", order);
      console.log("ITEMS:", items);

      if (!order) throw new Error("Order not found");

      // =========================
      // 2. CALCULATE AMOUNT
      // =========================
      const amount = items.reduce((sum, item) => {
        return sum + Number(item.total_price || 0);
      }, 0);

      console.log("CALCULATED AMOUNT:", amount);

      if (!amount || amount <= 0) {
        throw new Error("Amount not found in order items");
      }

      // =========================
      // 3. CREATE PAYMENT
      // =========================
      const paymentRes = await createPayment(order.id, amount);

      const payment = paymentRes.payment;
      const razorpayOrder = paymentRes.razorpay_order;

      console.log("PAYMENT:", payment);
      console.log("RAZORPAY ORDER:", razorpayOrder);

      if (!razorpayOrder?.id) {
        throw new Error("Razorpay order not created");
      }

      // =========================
      // 4. CHECK RAZORPAY SDK
      // =========================
      if (!window.Razorpay) {
        throw new Error("Razorpay SDK not loaded");
      }

      // =========================
      // 5. OPEN RAZORPAY
      // =========================
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY,
        amount: razorpayOrder.amount,
        currency: "INR",
        name: "Your Store",
        order_id: razorpayOrder.id,

        handler: async function (response) {
          try {
            await verifyPayment({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            });

            alert("Payment Successful 🎉");

            // 🔥 IMPORTANT FIX: use PUBLIC ORDER ID (ORD-xxxx)
            navigate(`/user/ordersuccess/${order.order_id}`);

          } catch (err) {
            console.log("Verification error:", err);
            alert("Payment verification failed");
          }
        },

        theme: {
          color: "#3399cc",
        },
      };

      const razor = new window.Razorpay(options);
      razor.open();

    } catch (err) {
      console.log("🔥 FULL PAYMENT ERROR:");
      console.log(err.response?.data || err.message || err);

      alert("Payment failed to start");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    handlePayment();
  }, []);

  return (
    <div>
      <h2>Processing Payment...</h2>
      {loading && <p>Please wait...</p>}
    </div>
  );
};

export default PaymentPage;
